import React, { useState, useEffect, useRef } from 'react';
import './Sidebar.css';

const API_URL   = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const MOBILE_BP = 768;
/* Tablet (F6#2b): entre 768 y 1100px la app renderiza en modo desktop, pero la
   sidebar expandida (220px) deja el contenido en ~740px y estrangula tablas, el
   POS y los grids. Auto-colapsamos la sidebar en ese rango (→72px, contenido
   ~888px). La preferencia MANUAL del usuario gana sobre el auto-colapso durante
   la sesión (manualRef) — un tablet siempre puede volver a ver los nombres. */
const TABLET_BP = 1100;
/* Preferencia del usuario (refactor UI F1): sidebar colapsada u expandida.
   Los anchos viven en index.css (--sidebar-w-collapsed / --sidebar-w-expanded). */
const COLLAPSE_KEY = 'sh:sidebar-collapsed';

const isTabletWidth = (w) => w >= MOBILE_BP && w <= TABLET_BP;

function readCollapsed() {
  try { return localStorage.getItem(COLLAPSE_KEY) === '1'; } catch { return false; }
}

/* ── Íconos SVG ─────────────────────────────────────────────── */
const icons = {
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
      <rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/>
    </svg>
  ),
  catalog: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
      <polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
    </svg>
  ),
  inventory: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="21 8 21 21 3 21 3 8"/>
      <rect x="1" y="3" width="22" height="5" rx="1"/>
      <line x1="10" y1="12" x2="14" y2="12"/>
    </svg>
  ),
  orders: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
    </svg>
  ),
  sales: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23"/>
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>
  ),
  customers: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  resumen: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 2v20l3-2 3 2 3-2 3 2 3-2V2l-3 2-3-2-3 2-3-2-3 2z"/>
      <line x1="8" y1="9" x2="16" y2="9"/><line x1="8" y1="13" x2="16" y2="13"/>
      <line x1="8" y1="17" x2="12" y2="17"/>
    </svg>
  ),
  trends: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
      <polyline points="17 6 23 6 23 12"/>
    </svg>
  ),
  marketing: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
      <path d="M19.07 4.93a10 10 0 0 1 0 14.14"/>
    </svg>
  ),
  cashflow: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 7H5a2 2 0 0 0 0 4h14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h14"/>
      <path d="M16 14h.01"/>
    </svg>
  ),
  costs: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 8V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2"/>
      <path d="M3 8h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8z"/>
      <path d="M8 12h8"/>
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  ),
  logout: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
      <polyline points="16 17 21 12 16 7"/>
      <line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  ),
  /* Tres puntos horizontales (MoreHorizontal) */
  more: (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
      <circle cx="5"  cy="12" r="1.5"/>
      <circle cx="12" cy="12" r="1.5"/>
      <circle cx="19" cy="12" r="1.5"/>
    </svg>
  ),
  /* Ícono de auditoría / log (FileText) */
  audit: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/>
      <line x1="16" y1="17" x2="8" y2="17"/>
      <polyline points="10 9 9 9 8 9"/>
    </svg>
  ),
  finanzas: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/>
      <line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6"  y1="20" x2="6"  y2="14"/>
      <line x1="2"  y1="20" x2="22" y2="20"/>
    </svg>
  ),
  /* Doble chevron para colapsar/expandir (ChevronsLeft) — rota 180° colapsado */
  collapse: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="11 17 6 12 11 7"/>
      <polyline points="18 17 13 12 18 7"/>
    </svg>
  ),
  /* Analítica — chart-line de lucide (F1-B1) */
  analitica: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3v16a2 2 0 0 0 2 2h16"/>
      <path d="m19 9-5 5-4-4-3 3"/>
    </svg>
  ),
  /* Agenda — calendario (lucide calendar). AG-1: módulo opcional por tienda. */
  agenda: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2"/>
      <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  ),
  /* Hunter — asistente IA (Sparkles de lucide). Rompe el patrón ícono-objeto de
     los módulos a propósito: Hunter es una CAPACIDAD, no un destino. */
  hunter: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .962 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.962 0z"/>
      <path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/>
    </svg>
  ),
};

// Caja: admin y coordinador. Costos: solo admin.
const VISIBLE_FOR_ROLE = {
  coordinador: new Set(['home', 'catalog', 'inventory', 'sales', 'orders', 'resumen', 'customers', 'cashflow']),
  // inicio-centro-control B2: el vendedor gana 'home' (Centro de control con sus 4 cuadros).
  vendedor:    new Set(['home', 'sales', 'orders', 'resumen', 'inventory', 'catalog']),
};

function canSee(itemId, role) {
  if (role === 'admin') return true;
  const set = VISIBLE_FOR_ROLE[role] ?? VISIBLE_FOR_ROLE.vendedor;
  return set.has(itemId);
}

/* Grupos del sidebar (refactor UI F1, aprobados por Miguel 2026-07-21).
   Expandida: etiqueta de grupo + ícono + nombre. Colapsada: separador + ícono con
   tooltip. Configuración/Usuarios suben del popover "···" a Sistema (mismo gating
   de rol de siempre); el popover conserva Auditoría y Cerrar sesión. */
const NAV_GROUPS = [
  { label: 'Operación', items: [
    // inicio-centro-control B2: Inicio entra al sidebar de ESCRITORIO — hasta acá solo era
    // alcanzable desde la tab bar móvil, y un Centro de control inalcanzable en desktop es
    // un módulo dormido (la lección de «backend sin UI»).
    { id: 'home',      label: 'Inicio',            icon: icons.home      },
    { id: 'sales',     label: 'Ventas',            icon: icons.sales     },
    { id: 'orders',    label: 'Pedidos',           icon: icons.orders    },
    { id: 'inventory', label: 'Inventario',        icon: icons.inventory },
    { id: 'costs',     label: 'Compras',           icon: icons.costs     },
    { id: 'agenda',    label: 'Agenda',            icon: icons.agenda    },
  ]},
  { label: 'Comercial', items: [
    { id: 'catalog',   label: 'Catálogo',          icon: icons.catalog   },
    { id: 'customers', label: 'Clientes',          icon: icons.customers },
    { id: 'analitica', label: 'Analítica',         icon: icons.analitica },
  ]},
  { label: 'Finanzas', items: [
    { id: 'resumen',   label: 'Resumen de ventas', icon: icons.resumen   },
    { id: 'finanzas',  label: 'Finanzas',          icon: icons.finanzas  },
    { id: 'cashflow',  label: 'Caja',              icon: icons.cashflow  },
  ]},
  { label: 'Sistema', items: [
    { id: 'settings',  label: 'Configuración',     icon: icons.settings  },
    { id: 'users',     label: 'Usuarios',          icon: icons.users     },
    { id: 'uikit',     label: 'UI Kit (dev)',      icon: icons.audit     },
    { id: 'maquetaweb', label: 'Maqueta Web (dev)', icon: icons.audit    },
  ]},
];

/* Configuración/Usuarios tienen gating propio (no están en VISIBLE_FOR_ROLE):
   el mismo que tenía el popover — settings: admin u owner; users: solo owner. */
function itemVisible(id, role, isOwner, analiticaOn = false, agendaOn = false) {
  if (id === 'uikit') return process.env.NODE_ENV === 'development' && (role === 'admin' || isOwner);
  if (id === 'maquetaweb') return process.env.NODE_ENV === 'development' && (role === 'admin' || isOwner);
  if (id === 'users') return isOwner;
  if (id === 'settings') return role === 'admin' || isOwner;
  // F1-B1: Analítica es módulo OPCIONAL por tienda — sin flag no hay menú, ni para admin.
  if (id === 'analitica') return analiticaOn && (role === 'admin' || isOwner);
  // AG-1: Agenda es módulo OPCIONAL por tienda — sin flag no hay menú (admin/coordinador/owner).
  if (id === 'agenda') return agendaOn && (role === 'admin' || role === 'coordinador' || isOwner);
  return canSee(id, role);
}

function syncSidebarVar(isMobile, collapsed) {
  document.documentElement.style.setProperty(
    '--sidebar-w',
    isMobile ? '0px' : (collapsed ? 'var(--sidebar-w-collapsed)' : 'var(--sidebar-w-expanded)')
  );
}

function Sidebar({
  activePage,
  onNavigate,
  badges = {},
  config,
  onLogout,
  mobileOpen,        // kept for API compat — sidebar is hidden on mobile via CSS
  onMobileClose,
  onOpenAssistant,   // abre el panel de Hunter (estado en App); reemplaza el FAB
  assistantName = 'Hunter',
  userRole = 'admin',
  isOwner = false,
}) {
  const [collapsed, setCollapsed] = useState(readCollapsed);
  /* La elección MANUAL (clic en colapsar/expandir) gana sobre el auto-colapso de
     tablet durante la sesión. DEBE ser state, no ref: en tablet auto-colapsada el
     `collapsed` guardado ya vale false, así que el clic de expandir hace
     setCollapsed(false) → no-op → React bailea el render → un ref jamás surtiría
     efecto (el primer clic quedaría muerto). Como state, marcar el override fuerza
     el re-render y effCollapsed se recalcula. Se reinicia al recargar (auto-colapso
     vuelve a mandar), que es justo el alcance "mientras esté en esa sesión". */
  const [manualOverride, setManualOverride] = useState(false);
  /* Expansión por hover (decisión de Miguel en la prueba de F1): colapsada, el
     sidebar se expande al pasar el mouse como OVERLAY — flota sobre el contenido
     sin tocar --sidebar-w, así la página NUNCA se re-acomoda por un hover. */
  const [hoverOpen, setHoverOpen] = useState(false);
  const hoverTimerRef = useRef(null);
  const [isTablet, setIsTablet] = useState(() => isTabletWidth(window.innerWidth));
  const [isMobile, setIsMobile] = useState(() => {
    const mobile = window.innerWidth < MOBILE_BP;
    // Sincronizar inmediatamente en el mismo tick que la inicialización
    // para evitar el flash de sidebar visible en el primer render. En tablet
    // arranca colapsada (sin override manual todavía).
    syncSidebarVar(mobile, readCollapsed() || isTabletWidth(window.innerWidth));
    return mobile;
  });
  const [moreOpen, setMoreOpen] = useState(false);
  const moreRef = useRef(null);
  const navRef = useRef(null);
  const [navScrollable, setNavScrollable] = useState(false);

  /* Estado EFECTIVO de colapso = lo que se ve y mueve --sidebar-w:
     · con override manual esta sesión → la preferencia del usuario (`collapsed`);
     · sin override → colapsada si es tablet, si no la preferencia guardada. */
  const effCollapsed = collapsed || (isTablet && !manualOverride);

  useEffect(() => {
    // Solo el estado FIJADO mueve --sidebar-w (el hover jamás reacomoda la página)
    syncSidebarVar(isMobile, effCollapsed);
  }, [isMobile, effCollapsed]);

  useEffect(() => () => clearTimeout(hoverTimerRef.current), []);

  const toggleCollapsed = () => {
    clearTimeout(hoverTimerRef.current);
    setHoverOpen(false);
    // La acción manual gana sobre el auto-colapso de tablet (esta sesión).
    setManualOverride(true);
    // Togglea desde lo que se VE (effCollapsed), no desde la preferencia guardada:
    // si estaba auto-colapsada en tablet, el primer clic debe EXPANDIR.
    const next = !effCollapsed;
    try { localStorage.setItem(COLLAPSE_KEY, next ? '1' : '0'); } catch { /* sin storage: solo esta sesión */ }
    setCollapsed(next);
  };

  /* Delay de entrada corto: una pasada accidental del mouse no abre el overlay */
  const handleMouseEnter = () => {
    if (!effCollapsed) return;
    clearTimeout(hoverTimerRef.current);
    hoverTimerRef.current = setTimeout(() => setHoverOpen(true), 180);
  };

  const handleMouseLeave = () => {
    clearTimeout(hoverTimerRef.current);
    setHoverOpen(false);
  };

  /* Activar scroll en .sidebar-nav solo cuando los módulos realmente exceden
     el alto disponible, para no recortar los tooltips en el caso normal.
     Sin esto, "···" y el avatar de abajo quedarían inalcanzables si el
     contenido es más alto que el viewport. */
  useEffect(() => {
    const el = navRef.current;
    if (!el || isMobile) return;
    const check = () => setNavScrollable(el.scrollHeight > el.clientHeight + 1);
    check();
    const ro = new ResizeObserver(check);
    ro.observe(el);
    window.addEventListener('resize', check);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', check);
    };
  }, [isMobile, userRole, effCollapsed]);

  useEffect(() => {
    // El sync de --sidebar-w lo hace el efecto [isMobile, effCollapsed]
    const onResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BP);
      setIsTablet(isTabletWidth(window.innerWidth));
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  /* Cerrar popover al clicar fuera o presionar Escape */
  useEffect(() => {
    if (!moreOpen) return;
    const handler = (e) => {
      if (e.type === 'mousedown' && moreRef.current && !moreRef.current.contains(e.target)) {
        setMoreOpen(false);
      }
      if (e.type === 'keydown' && e.key === 'Escape') {
        setMoreOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('keydown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('keydown', handler);
    };
  }, [moreOpen]);

  // F7 marca por tienda: nombre/logo salen del doc de tiendas (config.tienda) si está; si no, de
  // la config global (SH intacto). Una tienda NO-SH sin logo propio NO muestra el logo de SH.
  const brandName = config?.tienda?.nombre || config?.negocio?.nombre || 'Shopping Hunters';
  const logoPath  = config?.tienda?.logoPath || config?.negocio?.logoPath || null;
  const esTiendaSH = !config?.tienda || config.tienda.plataforma === 'woo';
  const hunterName = (assistantName && assistantName.trim()) || 'Hunter';

  const handleNavigate = (id) => {
    onNavigate(id);
    if (isMobile) onMobileClose?.();
  };

  /* Navegar desde el popover: cierra el popover primero */
  const handleMoreNav = (id) => {
    setMoreOpen(false);
    handleNavigate(id);
  };

  /* El botón "..." se muestra activo con el popover abierto ('audit' ya no es
     página: mapea a Usuarios/tab Auditoría vía LEGACY_PAGE_MAP) */
  const moreIsActive = moreOpen;

  /* Colapsada + hover = overlay expandido visualmente (sin mover --sidebar-w) */
  const visualCollapsed = effCollapsed && !hoverOpen;

  // En móvil no renderizamos nada — la navegación la maneja MobileTabBar.
  // Esto es más seguro que depender de display:none porque evita que
  // isMobile=false en el primer render de iOS Safari setee --sidebar-w:72px
  // como inline style (que ganaría sobre la media query CSS).
  if (isMobile) return null;

  return (
    <aside
      className={`sidebar${visualCollapsed ? ' sidebar--collapsed' : ''}${effCollapsed && hoverOpen ? ' sidebar--overlay' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Logo + nombre (el nombre solo expandida) */}
      <div className="sidebar-brand" data-label={brandName}>
        {logoPath
          ? <img src={`${API_URL}${logoPath}`} alt={brandName} className="sidebar-brand-logo" />
          : esTiendaSH
            ? <img src="/logo_shopping_hunters_small.png" alt={brandName} className="sidebar-brand-logo" />
            : null /* otra tienda sin logo propio: solo el nombre, nunca el logo de SH */
        }
        <span className="sidebar-brand-name">{brandName}</span>
      </div>

      {/* Navegación por grupos */}
      <nav ref={navRef} className={`sidebar-nav${navScrollable ? ' sidebar-nav--scrollable' : ''}`}>
        {NAV_GROUPS.map((group) => {
          const visibles = group.items.filter((item) => itemVisible(item.id, userRole, isOwner, !!config?.analitica_activa, !!config?.agenda_activa));
          if (visibles.length === 0) return null;
          return (
            <div key={group.label} className="sidebar-group">
              {/* El span permite ocultar el texto en colapsado y dibujar el
                  separador en la MISMA caja (invariante de geometría) */}
              <div className="sidebar-group-label" aria-hidden="true"><span>{group.label}</span></div>
              {visibles.map((item) => {
                const badge = badges[item.id] || 0;
                const isActive = activePage === item.id;
                return (
                  <button
                    key={item.id}
                    className={`nav-item${isActive ? ' nav-item--active' : ''}`}
                    onClick={() => handleNavigate(item.id)}
                    data-label={item.label}
                    aria-label={item.label}
                  >
                    <span className="nav-icon-wrap">
                      <span className="nav-icon">{item.icon}</span>
                    </span>
                    <span className="nav-label">{item.label}</span>
                    {badge > 0 && (
                      <span className="nav-badge" aria-label={`${badge} ${badge === 1 ? 'pedido nuevo' : 'pedidos nuevos'}`}>
                        {badge > 99 ? '99+' : badge}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          );
        })}
      </nav>

      {/* Parte inferior: colapsar + "···" + avatar */}
      <div className="sidebar-bottom">

        {/* Colapsar/expandir — preferencia persistida; NUNCA se expande por hover */}
        <button
          className="nav-item sidebar-collapse-btn"
          onClick={toggleCollapsed}
          data-label={effCollapsed ? 'Dejar expandido' : 'Colapsar menú'}
          aria-label={effCollapsed ? 'Dejar expandido' : 'Colapsar menú'}
          aria-expanded={!effCollapsed}
        >
          <span className="nav-icon-wrap">
            {/* La rotación sigue al estado EFECTIVO (incluye auto-colapso de tablet) */}
            <span className={`nav-icon sidebar-collapse-icon${effCollapsed ? ' is-collapsed' : ''}`}>{icons.collapse}</span>
          </span>
          <span className="nav-label">{effCollapsed ? 'Dejar expandido' : 'Colapsar'}</span>
        </button>

        {/* Botón "···" con popover hacia arriba (Auditoría + Cerrar sesión) */}
        <div className="sidebar-more-wrap" ref={moreRef}>
          <button
            className={`nav-item${moreIsActive ? ' nav-item--active' : ''}`}
            onClick={() => setMoreOpen(v => !v)}
            data-label="Más opciones"
            aria-label="Más opciones"
          >
            <span className="nav-icon-wrap">
              <span className="nav-icon">{icons.more}</span>
            </span>
            <span className="nav-label">Más opciones</span>
          </button>

          {moreOpen && (
            <div className="sidebar-popover" role="menu">
              {isOwner && (
                <button
                  className="sidebar-popover-item"
                  role="menuitem"
                  onClick={() => handleMoreNav('audit')}
                >
                  <span className="sidebar-popover-icon">{icons.audit}</span>
                  <span>Auditoría</span>
                </button>
              )}
              {isOwner && <div className="sidebar-popover-sep" />}
              {onLogout && (
                <button
                  className="sidebar-popover-item sidebar-popover-item--logout"
                  role="menuitem"
                  onClick={() => { setMoreOpen(false); onLogout(); }}
                >
                  <span className="sidebar-popover-icon">{icons.logout}</span>
                  <span>Cerrar sesión</span>
                </button>
              )}
            </div>
          )}
        </div>

        {/* Hunter — asistente IA (F4 §14, reemplaza al avatar decorativo y al FAB).
            Tratamiento aparte del resto: separador + acento violeta, para que lea
            como CAPACIDAD y no como un módulo o un control del sistema. */}
        {onOpenAssistant && (
          <>
            <div className="sidebar-hunter-sep" aria-hidden="true" />
            <button
              className="nav-item sidebar-hunter"
              onClick={onOpenAssistant}
              data-label={hunterName}
              aria-label={`Abrir asistente ${hunterName}`}
            >
              <span className="nav-icon-wrap">
                <span className="nav-icon">{icons.hunter}</span>
              </span>
              <span className="nav-label">{hunterName}</span>
            </button>
          </>
        )}
      </div>
    </aside>
  );
}

export default Sidebar;
